import type { IGif } from '@giphy/js-types'

import { addNoFreestarParam, relativeUrl } from '@/util/url'

export const getGifNavigationUrl = (
    gif: Pick<IGif, 'url' | 'decision'>,
    suppressFreestarOnPromotedClick: boolean
): string => {
    const destination = relativeUrl(gif.url)
    return suppressFreestarOnPromotedClick && gif.decision ? addNoFreestarParam(destination) : destination
}
